import styled from 'styled-components';
import { DEFAULT_FONT_STACK } from './constants';
import { breakpoints } from '@chegg-ui/theme';
export var BlockedRegionTitle = styled.h1.withConfig({
  componentId: "sc-11d8app-0"
})(["position:static;font-family:Aspira;font-size:32px;font-weight:bold;line-height:120%;padding:24px 36px;margin:auto;color:#222222;"]);
export var BlockedRegionText = styled.p.withConfig({
  componentId: "sc-11d8app-1"
})(["position:static;font-family:Aspira;font-size:18px;line-height:150%;padding:0 36px 18px 36px;margin:auto;color:#222222;"]);
export var ActionButtons = styled.div.withConfig({
  componentId: "sc-11d8app-2"
})(["display:flex;flex-direction:row;align-self:flex-end;"]);
export var NoThanksButton = styled.button.withConfig({
  componentId: "sc-11d8app-3"
})(["background:none;border:none;margin:auto;font-family:Aspira;font-size:20px;line-height:24px;font-weight:bold;color:#00799e;display:flex;&:hover{text-decoration:underline;}"]);
export var SureButton = styled.button.withConfig({
  componentId: "sc-11d8app-4"
})(["width:89px;height:44px;background:", ";border:none;border-radius:100px;margin:0px 16px;p{font-family:Aspira;margin:auto;font-size:24px;font-weight:600;color:#ffffff;}"], function (props) {
  return props.buttonStyle.backgroundColor;
});
export var DismissButtonWrapper = styled.button.withConfig({
  componentId: "sc-11d8app-5"
})(["align-self:flex-end;background-color:white;border:none;"]);
export var BlockedRegionContentContainer = styled.div.withConfig({
  componentId: "sc-11d8app-6"
})(["height:fit-content;display:flex;flex-direction:column;position:relative;padding:32px;background:#ffffff;box-sizing:border-box;font-family:", ";margin:auto auto;@media screen and (max-width:375px){width:100%;overflow:auto;}@media (min-width:375px) and (max-width:", "){width:400px;}@media (min-width:", "){width:600px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.font ? theme.font : DEFAULT_FONT_STACK;
}, breakpoints.lg.min, breakpoints.lg.min);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/components/BlockedRegionContent/styled.js
// module id = 1243
// module chunks = 11